/**
 * 日期时间格式化
 *
 * @param time - 需要转换的时间
 * @param fmt - 需要转换的格式 如：`yyyy-MM-dd`、`yyyy-MM-dd HH:mm:ss`
 */
export function formatTime(time: Date | number | string, fmt: string) {
    if (!time) return '';
    else {
        const date = new Date(time);
        const o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'H+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
            'q+': Math.floor((date.getMonth() + 3) / 3),
            S: date.getMilliseconds(),
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (const k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
        }
        return fmt;
    }
}
export function getHoursAndMinutes() {
    const date = new Date();
    const hh = '0' + date.getHours(),
        mm = '0' + date.getMinutes();
    return `${hh.slice(-2)}:${mm.slice(-2)}`;
}

export function getMonthToMinutes() {
    const date = new Date();
    const MM = '0' + (date.getMonth() + 1),
        DD = '0' + date.getDate(),
        hh = '0' + date.getHours(),
        mm = '0' + date.getMinutes();
    return `${MM.slice(-2)}${DD.slice(-2)}_${hh.slice(-2)}${mm.slice(-2)}`;
}

export function getServerEnv(env = process.env.REACT_APP_ENV) {
    switch (env) {
        case 'development':
        case 'pre':
            return 'pre';
        case 'beta':
            return 'beta';
        case 'production':
        case 'release':
            return 'release';
        default:
            return 'release';
    }
}

export const registerStyleSheet = (styleCode: string, id?: string) => {
    const style = document.createElement('style');
    style.innerHTML = styleCode;
    if (id) {
        style.id = id;
    }
    document.body.appendChild(style);
    const remove = () => {
        document.body.removeChild(style);
    };
    return remove;
};

/**
 * 创建一个通用的空闲时执行函数
 *
 * @param cbk - 需要执行的函数
 */
let executeHandler: any;
export const executeWhenIdle = <T>(cbk: () => Promise<T>): Promise<T> => {
    return new Promise((resolve) => {
        const runSave = () => {
            cbk().then(resolve);
        };

        if (window.requestIdleCallback) {
            // 使用requestIdleCallback在浏览器空闲时执行
            window.requestIdleCallback(
                () => {
                    runSave();
                },
                { timeout: 10000 },
            ); // 设置10秒超时，确保即使浏览器繁忙也会执行
        } else {
            // 降级处理：使用setTimeout
            clearTimeout(executeHandler);
            executeHandler = setTimeout(() => {
                runSave();
            }, 10000);
        }
    });
};

/**
 * React 组件的 props 属性浅比较
 *
 * @param oldProps - 旧的组件属性
 * @param newProps - 新的组件属性
 * @param ignoreKeys - 可选；忽略的 Key
 */
export const arePropsEqual = (oldProps: any, newProps: any, ignoreKeys: string[] = []) => {
    const keys = [...new Set([...Object.keys(oldProps), ...Object.keys(newProps)])];
    for (const key of keys) {
        if (ignoreKeys.includes(key)) continue;
        if (oldProps[key] !== newProps[key]) {
            return false;
        }
    }
    return true;
};
